export const PREV_CART_VERSION = process.env.PREV_CART_VERSION || 'unset';
export const CURRENT_CART_VERSION = process.env.CURRENT_CART_VERSION || 'unset';
export const CART_EXPIRES = 180;
export const CART_COOKIE_PATH = '/snow';
export const DATE_FORMAT = 'yyyy-MM-dd';
